import type { DocVariableSnapshot } from "@/lib/document-builder/versions/snapshotTypes";
import { isValidDocVariableKey, normalizeDocVariableKey } from "@/lib/document-builder/variables/variableKey";

export function createEmptyDocVariable(): DocVariableSnapshot {
  return {
    key: "",
    label: "",
    default_value: "",
    required: false,
  };
}

export function labelToVariableKey(label: string): string {
  const cleaned = label
    .trim()
    .replace(/[^A-Za-z0-9]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");
  return cleaned && isValidDocVariableKey(cleaned) ? cleaned : "";
}

export function normalizeDocVariablesForSave(
  variables: DocVariableSnapshot[],
): DocVariableSnapshot[] | { error: string } {
  const out: DocVariableSnapshot[] = [];
  const seen = new Set<string>();

  for (const row of variables) {
    const key = normalizeDocVariableKey(row.key);
    const label = row.label.trim();
    if (!key && !label) continue;
    if (!key || !isValidDocVariableKey(key)) {
      return { error: `Variable key "${row.key}" is invalid` };
    }
    if (!label) {
      return { error: `Variable ${key} needs a label` };
    }
    if (seen.has(key)) {
      return { error: `Duplicate variable key: ${key}` };
    }
    seen.add(key);
    out.push({
      key,
      label,
      default_value: row.default_value.trim(),
      required: row.required,
    });
  }

  return out;
}
